/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./invite.defs.js";
export { main as default } from "./invite.defs.js";
